const deleteEquipmentUseCase = (repository) => async (id) => {
    return await repository(id);
}

export default deleteEquipmentUseCase;